/**
 * 平台内限制常量定义
 */
export enum ConfigEnum {
  // 任务添加执行人最大数量
  ADD_EXECUTOR_SELECT_MAX_NUM = 10000,
  // 会议交付物执行人参会人最大数量
  MEETING_EXECUTOR_LIMIT = 500,
  // 任务要求最大限制字数
  TASK_REQUIREMENT_MAX_LENGTH = 5000,
  // 执行提示最大限制字数
  TASK_PROJECT_NOTICE_MAX_LENGTH = 5000,
  TASK_REMARK_MAX_LENGTH = 500,
  // 输出内容
  TASK_OUTRESULT_MAX_LENGTH = 500,
  // 任务协助人上限
  TASK_ASSIST_USER_MAX_LENGTH = 100,
  // 批量发布最大限制
  BATCH_PUBLISH_MAX_NUM = 1000,
  // 任务销售价、采购价最大值
  TASK_PRICE_MAX_NUM = 9999999.99,
  // 企业服务金额最大限制
  ENTERPRISE_SERVICE_PRICE_MAX_NUM = 99999999,
  // 导出最大数量
  EXPORT_MAX_NUMBER = 500,
  UPLOAD_ASYNC_MAX_LENGTH = 20,
}

export enum FileEnum {
  // 批量上传压缩文件上限 200M
  BATCH_UPLOAD_MAX_SIZE = 200,
  BATCH_IMPORT_MAX_SIZE = 500,
  SINGLE_UPLOAD_MAX_SIZE = 50,
  SINGLE_UPLOAD_INFOMATION_MAX_SIZE = 100,
  VIDEO_UPLOAD_MAX_SIZE = 2, // 视频文件大小限制 2G
  BATCH_IMPORT_PROJECT_MAX_SIZE = 10,
}

// 项目类型
export enum PrjInitTypeEnum {
  // 承接项目
  INFO_PRJ_INIT = 'info_prj_init',
  // 自营项目
  SELF_PRJ_INIT = 'self_prj_init',
  //委托项目
  ENTRUST_PRJ_INIT = 'entrust_prj_init',
}
// 项目来源
export enum PrjSourceEnum {
  //苁蓉项目管理平台
   SPP_PLATFORM= 'spp_platform',
  // 数字化
  DIG_PLATFORM = 'dig_platform',
}

// 项目来源
export enum PrjSourceTextEnum {
  //苁蓉项目管理平台
  SPP_PLATFORM_TEXT= '苁蓉项目管理平台',
  //数字化营销平台
  DIG_PLATFORM_TEXT = '数字化营销平台',
}

// 计划类型
export enum PlanTypeEnum {
  // 融合任务
  FUSION_TASK = 'fusion_task',
  // 独立任务
  INTEGRATION_TASK = 'integration_task',
}

export enum TimeFormatEnum {
  YEAR_MONTH_DAY = 'YYYY-MM-DD',
}
// 支付平台
export enum PayPlatformEnum {
  NoPay = 'notPayment',
  YCS = 'LingGong', // 云财税
  YZH = 'cloudAccount', // 云账户
  LYPT = 'LingYue', // 医恋通
  LIX = 'LiXiang', // 理象
}

// 支付平台
export enum ComplianceRuleConditionTypeEnum {
  Trigger = 'trigger',
  Logic = 'logic'
}

// 计划类型
export enum PrjExecutorType {
  // 推广服务商
  OUTSIDER = 'outsider',
  // 医生
  DOCTOR = 'doctor',
  // 运营专员
  REPRESENT = 'represent',
  // 医生&运营专员
  DOCTOR_REPRESENT = 'doctor_represent',
  // 企业员工
  EMPLOYEE = 'employee',
}

// 推广交付物类型
export const PopContentTypes = [
  { label: '资讯', value: 'information' },
  { label: '视频', value: 'video' },
  { label: '直播视频', value: 'live' },
  { label: '会议视频', value: 'meeting' },
]
